import axios from "axios";

export default {
    saveCompanySecuritySettings: async (companyId, payload) => {
        const { data } = await axios.post(`/company/${companyId}/settings/security`, payload)

        return data
    },
}